import { Box } from "@ui/box/Box";

export interface ICountryFlagProps {
	code: string;
	variant?: "circle" | "rectangle";
}

export const CountryFlag = ({ code, variant = "circle" }: ICountryFlagProps) => {
	const isRectangle = variant === "rectangle";

	return (
		<Box
			sx={{
				borderRadius: isRectangle ? "3px" : "50%",
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
				width: isRectangle ? "24px" : "25px",
				height: isRectangle ? "16px" : "25px",
				border: isRectangle ? "1px solid white" : "2px solid white",
				outline: "1px solid rgba(0,0,0,.16)",
				flexShrink: 0,
			}}
			style={{
				backgroundImage: `url('https://flagcdn.com/${(code ?? "eu")?.toString().toLowerCase()}.svg')`,
			}}
		/>
	);
};
